var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 164,
    viewBox: "0 0 166 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2514 141C128.995 141 158.783 111.148 158.783 74.1958C158.783 37.2431 128.863 7.3916 92.2514 7.3916C55.5084 7.3916 25.7202 37.2431 25.7202 74.1958C25.7202 111.148 55.5084 141 92.2514 141Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.452 30.4054C157.424 30.4054 159.832 27.9915 159.832 25.0137C159.832 22.036 157.424 19.6221 154.452 19.6221C151.481 19.6221 149.072 22.036 149.072 25.0137C149.072 27.9915 151.481 30.4054 154.452 30.4054Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.326 9.36424C164.355 9.36424 166 7.7157 166 5.68212C166 3.64854 164.355 2 162.326 2C160.296 2 158.651 3.64854 158.651 5.68212C158.651 7.7157 160.296 9.36424 162.326 9.36424Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2632 30.2734C31.2924 30.2734 32.9375 28.6249 32.9375 26.5913C32.9375 24.5577 31.2924 22.9092 29.2632 22.9092C27.2339 22.9092 25.5889 24.5577 25.5889 26.5913C25.5889 28.6249 27.2339 30.2734 29.2632 30.2734Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82371 101.286C10.5923 101.286 13.6474 98.2242 13.6474 94.4476C13.6474 90.671 10.5923 87.6094 6.82371 87.6094C3.05508 87.6094 0 90.671 0 94.4476C0 98.2242 3.05508 101.286 6.82371 101.286Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15551_356439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.524 40.7942L138.574 125.483C138.574 128.376 136.212 130.612 133.325 130.612H50.9154C48.0284 130.612 45.6664 128.245 45.6664 125.483V16.5974C45.6664 13.7043 48.0284 11.4688 50.9154 11.4688H110.623L137.524 40.7942Z",
    fill: "url(#paint0_linear_15551_356439)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8214 113.647H82.8032C82.1471 113.647 81.6222 112.989 81.6222 112.2C81.6222 111.411 82.1471 110.754 82.8032 110.754H85.8214C86.4775 110.754 87.0024 111.411 87.0024 112.2C87.0024 113.121 86.4775 113.647 85.8214 113.647Z",
    fill: "#CED7E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6356 113.647H59.0514C58.3953 113.647 57.8704 112.989 57.8704 112.2C57.8704 111.411 58.3953 110.754 59.0514 110.754H76.6356C77.2917 110.754 77.8166 111.411 77.8166 112.2C77.8166 113.121 77.2917 113.647 76.6356 113.647Z",
    fill: "#D5DDEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0751 29.2209H59.5763C58.6577 29.2209 57.8704 28.4318 57.8704 27.5113C57.8704 26.5908 58.6577 25.8018 59.5763 25.8018H99.0751C99.9937 25.8018 100.781 26.5908 100.781 27.5113C100.781 28.4318 99.9937 29.2209 99.0751 29.2209Z",
    fill: "#D5DDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7984 38.6896H59.5763C58.6577 38.6896 57.8704 37.9006 57.8704 36.9801C57.8704 36.0595 58.6577 35.2705 59.5763 35.2705H74.6672C75.5858 35.2705 76.3731 36.0595 76.3731 36.9801C76.3731 37.9006 75.5858 38.6896 74.7984 38.6896Z",
    fill: "#D5DDEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.623 11.4688V34.8765C110.623 38.1641 113.51 40.7942 116.791 40.7942H137.524",
    fill: "#D5DDEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.823 132.584C142.511 132.584 141.198 132.058 140.149 130.875L118.234 108.913L117.447 109.439C110.36 114.7 102.093 117.461 93.6949 117.461C83.5905 117.461 73.4862 113.385 66.0063 106.283C58.1328 98.7875 53.8024 88.6617 53.8024 77.6153C53.8024 55.6541 71.649 37.7695 93.5636 37.7695C108.523 37.7695 121.646 45.6598 128.732 59.0732C135.687 72.3552 134.768 87.8727 126.239 100.366L125.714 101.155L147.76 123.247C149.99 125.483 149.466 127.718 149.072 128.902C148.022 131.006 145.923 132.584 143.823 132.584ZM93.5636 48.6844C77.5541 48.6844 64.6941 61.7033 64.6941 77.6153C64.6941 95.7629 79.5225 106.678 93.9573 106.678C102.749 106.678 110.754 102.733 116.397 95.6314C123.352 86.9521 124.533 75.2483 119.677 65.1224C114.691 54.9966 104.718 48.6844 93.5636 48.6844Z",
    fill: "#989FB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0972 82.3493C82.8031 82.3493 84.2466 80.9028 84.2466 79.1932C84.2466 77.4837 82.8031 76.0371 81.0972 76.0371C79.3912 76.0371 77.9478 77.4837 77.9478 79.1932C77.9478 80.9028 79.3912 82.3493 81.0972 82.3493Z",
    fill: "#989FB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.243 82.3493C106.949 82.3493 108.392 80.9028 108.392 79.1932C108.392 77.4837 106.949 76.0371 105.243 76.0371C103.537 76.0371 102.093 77.4837 102.093 79.1932C102.093 81.0343 103.537 82.3493 105.243 82.3493Z",
    fill: "#989FB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9741 68.7514L74.0461 72.5L74.9813 74.2357L81.9092 70.487L80.9741 68.7514Z",
    fill: "#989FB0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.814 68.7016L103.879 70.4375L110.808 74.1854L111.743 72.4495L104.814 68.7016Z",
    fill: "#989FB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1699 89.7126C95.1992 89.7126 96.8442 88.4762 96.8442 86.951C96.8442 85.4259 95.1992 84.1895 93.1699 84.1895C91.1407 84.1895 89.4956 85.4259 89.4956 86.951C89.4956 88.4762 91.1407 89.7126 93.1699 89.7126Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15551_356439",
    x: 23.6664,
    y: 0.46875,
    width: 136.907,
    height: 163.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15551_356439"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15551_356439",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15551_356439",
    x1: 92.0899,
    y1: 8.71286,
    x2: 92.0899,
    y2: 131.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileNotFound);
export default __webpack_public_path__ + "static/media/FileNotFound.98b9f856b336f5d8537ef0273a8f4381.svg";
export { ForwardRef as ReactComponent };